import {
  STANDALONE_DISABLED_ELEMENTS,
  UNIVERSALLY_DISABLED_ELEMENTS,
} from './data/constants';

export const DEFAULT_VIEWER_CONFIG: ViewerConfig = {
  pdftron: {
    disabledElements: UNIVERSALLY_DISABLED_ELEMENTS,
  },
  extractionsEnabled: false,
  tableExtractionsEnabled: false,
  suggestionAnnotations: {
    flyout: false,
  },
  readOnlyAnnotationImport: false,
  canDownloadPdf: false,
};

export type ViewerConfig = {
  pdftron: {
    disabledElements: readonly string[];
    initialToolbarGroup?: 'View' | 'Annotate';
  };
  // Service-level capabilities
  extractionsEnabled: boolean;
  tableExtractionsEnabled: boolean;
  // Cross-cutting annotation display behavior
  suggestionAnnotations: {
    flyout: boolean;
  };
  readOnlyAnnotationImport: boolean;
  canDownloadPdf: boolean;
};

type StandaloneViewerConfigFlags = {
  canDownloadPdf: boolean;
};

export const buildStandaloneViewerConfig = (
  flags: StandaloneViewerConfigFlags,
): ViewerConfig => ({
  pdftron: {
    disabledElements: [
      ...UNIVERSALLY_DISABLED_ELEMENTS,
      ...STANDALONE_DISABLED_ELEMENTS,
    ],
    initialToolbarGroup: 'View',
  },
  extractionsEnabled: false,
  tableExtractionsEnabled: true,
  suggestionAnnotations: {
    flyout: false,
  },
  readOnlyAnnotationImport: false,
  canDownloadPdf: flags.canDownloadPdf,
});

type PartLibraryConfigFlags = {
  isPdfRedactionEnabled: boolean;
  canDownloadPdf: boolean;
};

// NOTE: When Found In Files (FiF) is broken out as its own ecosystem app
// available in the Part Library, `suggestionAnnotations.flyout` should be
// flipped to `true` so FiF annotations can show the flyout with limited
// actions (info display, mark as inaccurate, future copy button).
export const buildPartLibraryConfig = (
  flags: PartLibraryConfigFlags,
): ViewerConfig => ({
  pdftron: {
    disabledElements: [
      ...UNIVERSALLY_DISABLED_ELEMENTS,
      ...(flags.isPdfRedactionEnabled ? [] : ['toolbarGroup-Redact']),
    ],
  },
  extractionsEnabled: false,
  tableExtractionsEnabled: false,
  suggestionAnnotations: {
    flyout: false,
  },
  readOnlyAnnotationImport: true,
  canDownloadPdf: flags.canDownloadPdf,
});

type QuotePartViewerConfigFlags = {
  isReqsReviewEnabled: boolean;
  isPdfRedactionEnabled: boolean;
  isBeamsEnabled: boolean;
  isRunesEnabled: boolean;
  canDownloadPdf: boolean;
};

export const buildQuotePartViewerConfig = (
  flags: QuotePartViewerConfigFlags,
): ViewerConfig => ({
  pdftron: {
    disabledElements: [
      ...UNIVERSALLY_DISABLED_ELEMENTS,
      ...(flags.isPdfRedactionEnabled ? [] : ['toolbarGroup-Redact']),
    ],
  },
  extractionsEnabled: flags.isRunesEnabled,
  tableExtractionsEnabled: flags.isBeamsEnabled,
  suggestionAnnotations: {
    flyout: true,
  },
  readOnlyAnnotationImport: true,
  canDownloadPdf: flags.canDownloadPdf,
});
